import { SessionDetails } from '@flowwai-frontend/shared/auth/common'

import { useRefreshTokenService } from '../services/useRefreshTokenService'

const useGetRefreshTokensAPI = () => {
   const refreshTokenService = useRefreshTokenService()

   const getRefreshTokenAPI = async (req: {
      accessToken: string
      refreshToken: string
   }): Promise<SessionDetails> => {
      const transformedReq = {
         access_token: req.accessToken,
         refresh_token: req.refreshToken
      }

      const response = await refreshTokenService.getRefreshAuthTokensAPI(
         transformedReq
      )

      return {
         accessToken: response.access_token,
         refreshToken: response.refresh_token,
         expiredInDays: response.expires_in_seconds / (3600 * 24)
      }
   }

   return getRefreshTokenAPI
}

export { useGetRefreshTokensAPI }
